// extracted by mini-css-extract-plugin
module.exports = {"avatarUpload":"StaffForm_avatarUpload__10FEL","asterisc":"StaffForm_asterisc__2KdyD"};